module.exports = __webpack_public_path__ + "img/NVillager64_ua.85b1b9c2.webp";